// src/pages/BCCManager/components/UserTable.jsx

import React from "react";

const COLUMNS = [
    { key: "name",  label: "Name"          },
    { key: "email", label: "Email Address"  },
];

export default function UserTable({
                                      users,
                                      onEdit,
                                      onDelete,
                                  }) {

    // ── Empty State ────────────────────────────────────────────────────────
    if (users.length === 0) {
        return (
            <div className="text-center py-20 px-6 text-gray-500 dark:text-gray-400">
                <p className="text-base font-medium mb-1">No recipients added yet.</p>
                <small className="text-sm">Click "Add Recipient" to get started.</small>
            </div>
        );
    }

    // ── Table ──────────────────────────────────────────────────────────────
    return (
        <div className="overflow-x-auto">
            <table className="w-full border-collapse text-sm">

                {/* Head */}
                <thead>
                <tr>

                    {/* # */}
                    <th className="bg-gray-50 dark:bg-navy-900 text-black dark:text-black font-semibold uppercase text-xs tracking-wide px-4 py-3 text-center border-b border-gray-200 dark:border-navy-700 w-12 whitespace-nowrap">
                        #
                    </th>

                    {/* Columns */}
                    {COLUMNS.map((col) => (
                        <th
                            key={col.key}
                            className="bg-gray-50 dark:bg-navy-900 text-black dark:text-black font-semibold uppercase text-xs tracking-wide px-4 py-3 text-left border-b border-gray-200 dark:border-navy-700 whitespace-nowrap"
                        >
                            {col.label}
                        </th>
                    ))}

                    {/* Actions */}
                    <th className="bg-gray-50 dark:bg-navy-900 text-black dark:text-black font-semibold uppercase text-xs tracking-wide px-4 py-3 text-left border-b border-gray-200 dark:border-navy-700 whitespace-nowrap">
                        Actions
                    </th>

                </tr>
                </thead>

                {/* Body */}
                <tbody>
                {users.map((user, index) => (
                    <tr
                        key={user.id}
                        className="hover:bg-gray-50 dark:hover:bg-navy-700 transition-colors duration-150"
                    >
                        {/* Index */}
                        <td className="px-4 py-3 border-b border-gray-100 dark:border-navy-700 text-center text-xs text-black dark:text-black">
                            {index + 1}
                        </td>

                        {/* Name */}
                        <td className="px-4 py-3 border-b border-gray-100 dark:border-navy-700">
                            <div className="flex items-center gap-2.5 font-semibold text-black dark:text-black whitespace-nowrap">
                                {user.name}
                            </div>
                        </td>

                        {/* Email */}
                        <td className="px-4 py-3 border-b border-gray-100 dark:border-navy-700">
                            <a
                                href={`mailto:${user.email}`}
                                className="text-black dark:text-black hover:underline text-xs"
                            >
                                {user.email}
                            </a>
                        </td>

                        {/* Actions */}
                        <td className="px-4 py-3 border-b border-gray-100 dark:border-navy-700">
                            <div className="flex items-center gap-1.5">

                                {/* Edit */}
                                <button
                                    onClick={() => onEdit(user)}
                                    className="flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-semibold border-none cursor-pointer transition-all duration-200 bg-indigo-50 dark:bg-indigo-900/30 text-black dark:text-black hover:bg-indigo-100 dark:hover:bg-indigo-900/50"
                                >
                                    ✏️ Edit
                                </button>

                                {/* Delete */}
                                <button
                                    onClick={() => onDelete(user.id)}
                                    className="flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-semibold border-none cursor-pointer transition-all duration-200 bg-red-50 dark:bg-red-900/30 text-black dark:text-black hover:bg-red-100 dark:hover:bg-red-900/50"
                                >
                                    🗑️ Delete
                                </button>

                            </div>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}